import { useSyncExternalStore } from "react";

/** Admin impersonation: the selected user id is stored locally and sent on every API request
 * via the `X-Impersonate-User-Id` header (validated server-side, admin-only). */
const STORAGE_KEY = "adia.impersonateUserId";
export const IMPERSONATION_EVENT = "adia:impersonation-changed";

export function getImpersonatedUserId(): string | null {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function setImpersonatedUserId(userId: string): void {
  window.localStorage.setItem(STORAGE_KEY, userId);
  window.dispatchEvent(new Event(IMPERSONATION_EVENT));
}

export function clearImpersonation(): void {
  window.localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(IMPERSONATION_EVENT));
}

function subscribe(callback: () => void): () => void {
  window.addEventListener(IMPERSONATION_EVENT, callback);
  window.addEventListener("storage", callback);
  return () => {
    window.removeEventListener(IMPERSONATION_EVENT, callback);
    window.removeEventListener("storage", callback);
  };
}

/** Reactive read of the currently impersonated user id (null when not impersonating). */
export function useImpersonatedUserId(): string | null {
  return useSyncExternalStore(subscribe, getImpersonatedUserId, () => null);
}
